import { WiredDashboardTaskList } from '@euler/app/tv/components/dashboard/TaskList';
import {
  DashboardTaskListTabItems,
  TaskListToolbar,
} from '@euler/app/tv/components/dashboard/TaskListToolbar';
import { kDashboardToolbarMarginTop } from '@euler/app/tv/functions/constants';
import { useTaskListWithSearch } from '@euler/app/tv/functions/useTaskListWithSearch';
import { useScreenContentPadding } from '@euler/app/tv/functions/utils';
import { usePresentationTheme } from '@euler/app/tv/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { View } from 'react-native';

export const DashboardScreen = wrapNavigatorScreen(() => {
  const theme = usePresentationTheme();
  const { rpx } = useResponsiveContext();
  const [marginLeft, marginRight] = useScreenContentPadding();
  const taskList = useTaskListWithSearch({
    tabItems: DashboardTaskListTabItems,
    initialTabType: 'default',
  });

  return (
    <View
      css={`
        flex: 1;
        background-color: ${theme.page.bg};
      `}
    >
      <TaskListToolbar
        activeTabType={taskList.activeTabType}
        activeListMode={taskList.preferredMode}
        onModeChanged={taskList.onPreferredModeChange}
        loading={taskList.isRefreshing}
        onTabChanged={taskList.onActiveTabTypeChange}
        css={`
          margin-top: ${rpx(kDashboardToolbarMarginTop)}px;
          padding-left: ${marginLeft}px;
          padding-right: ${marginRight - rpx(34)}px;
        `}
      />
      <WiredDashboardTaskList
        debugLabel="default"
        tasks={taskList.data}
        preferredMode={taskList.preferredMode}
        showStatus={false}
        showFinishedTime={false}
        isRefreshing={taskList.isRefreshing}
        isLoading={taskList.isLoading}
        hasMore={taskList.hasMore}
        error={taskList.error}
        emptyText={`暂无${taskList.activeTab.text}相关的车辆服务信息`}
        onRefresh={taskList.onRefresh}
        onFetchMore={taskList.onFetchMore}
      />
    </View>
  );
});
